"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _FolderTreeContainer = _interopRequireDefault(require("FileManagerCore/containers/FolderTreeContainer"));

var BrowseFolders =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BrowseFolders, _Component);

  function BrowseFolders(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BrowseFolders);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BrowseFolders).call(this, props));
    _this.state = {
      open: false,
      selectedFolder: null
    };
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangeFolder = _this.handleChangeFolder.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenChange = _this.handleOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClickChangeFolder = _this.handleClickChangeFolder.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BrowseFolders, [{
    key: "getSelectedFolder",
    value: function getSelectedFolder() {
      return this.state.selectedFolder || this.props.folder;
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(folder) {
      this.setState({
        selectedFolder: folder || (0, _FoldersAndFiles.getHomeFolder)()
      });
    }
  }, {
    key: "handleChangeFolder",
    value: function handleChangeFolder() {
      var onChangeFolder = this.props.onChangeFolder;
      var selectedFolder = this.state.selectedFolder;
      onChangeFolder(selectedFolder);
      this.setState({
        open: false,
        selectedFolder: null
      });
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "handleClickChangeFolder",
    value: function handleClickChangeFolder() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var _this$state = this.state,
          open = _this$state.open,
          selectedFolder = _this$state.selectedFolder;
      return _react.default.createElement(_UIPopover.default, {
        open: open,
        closeOnOutsideClick: true,
        onOpenChange: this.handleOpenChange,
        placement: "bottom",
        autoPlacement: false,
        content: {
          header: _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.selectFolder')),
          body: _react.default.createElement("div", {
            className: "browse-folders__folder-tree"
          }, _react.default.createElement(_FolderTreeContainer.default, {
            selectedFolder: this.getSelectedFolder(),
            onSelect: this.handleSelect
          })),
          footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
            use: "tertiary",
            size: "small",
            disabled: !selectedFolder,
            onClick: this.handleChangeFolder
          }, _I18n.default.text('FileManagerLib.actions.select')))
        }
      }, _react.default.createElement(_UILink.default, {
        className: className,
        onClick: this.handleClickChangeFolder
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.actions.browseFolders'))));
    }
  }]);
  return BrowseFolders;
}(_react.Component);

exports.default = BrowseFolders;
BrowseFolders.propTypes = {
  className: _react.PropTypes.string,
  folder: _react.PropTypes.instanceOf(_immutable.default.Map),
  onChangeFolder: _react.PropTypes.func.isRequired
};
module.exports = exports.default;